import { render, staticRenderFns } from "./SelectedServiceDetails.vue?vue&type=template&id=132a31de"
import script from "./SelectedServiceDetails.vue?vue&type=script&lang=js"
export * from "./SelectedServiceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports